import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListItemNumberModel from "../../../models/listItemNumberModel";

@Component
export default class TransportDocumentDgnDialog extends Vue {
    transportDocumentTypeId = null;
    netWeightKg = "";

    validation = {
        transportDocumentType: [(value: number) => !!value || this.$t("common.validationErrorRequired")],
        netWeightKg: [(value: string) => !!value || this.$t("common.validationErrorRequired")],
    }

    get showDialog(): boolean {
        return this.$store.direct.state.supervisorTransportDocument.showDgnDialog;
    }

    set showDialog(value: boolean) {
        this.$store.direct.commit.supervisorTransportDocument.setShowDgnDialog(value);
    }

    get title(): string {
        return this.$store.direct.state.supervisorTransportDocument.title;
    }

    get dgnTransportDocumentTypeList(): ListItemNumberModel[] {
        return this.$store.direct.state.supervisorTransportDocument.dgnTransportDocumentTypeList;
    }

    get currentSupervisorLoadingPlaceId(): undefined | number {
        return this.$store.direct.state.supervisorTransportDocument.currentSupervisorLoadingPlaceId;
    }

    set currentSupervisorLoadingPlaceId(val: undefined | number) {
        this.$store.direct.commit.supervisorTransportDocument.setCurrentSupervisorLoadingPlaceId(val);
    }

    get currentSupervisorUnloadingPlaceId(): undefined | number {
        return this.$store.direct.state.supervisorTransportDocument.currentSupervisorUnloadingPlaceId;
    }

    set currentSupervisorUnloadingPlaceId(val: undefined | number) {
        this.$store.direct.commit.supervisorTransportDocument.setCurrentSupervisorUnloadingPlaceId(val);
    }

    created() {
        this.$store.direct.dispatch.supervisorTransportDocument.loadDgnTransportDocumentTypeList();
    }

    cancelClick() {
        this.$store.direct.dispatch.supervisorTransportDocument.isNotConfirmedDgn();
    }

    async saveClick() {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (valid) {
            this.$store.direct.dispatch.supervisorTransportDocument.generateAndGetSupervisorDgnFile({
                transportDocumentTypeId: this.transportDocumentTypeId,
                netWeightKg: this.netWeightKg
            });
            await this.$store.direct.dispatch.supervisorTransportDocument.isConfirmedDgn();

            this.currentSupervisorLoadingPlaceId = undefined;
            this.currentSupervisorUnloadingPlaceId = undefined;
            this.netWeightKg = "";
        }
    }
}
